import { useEffect, useState } from 'react';
import { countryFactory } from './index';

export const useCountryAddressFormat = (countryCode) => {
  const [addressFormat, setAddressFormat] = useState({ elements: [] });

  useEffect(() => {
    const country = countryFactory(countryCode);
    setAddressFormat(country.addressFormat);
  }, [countryCode]);

  return addressFormat;
};
